import DeleteModal from './delete-modal';
export default DeleteModal;
